import { Spinner } from '@chakra-ui/react';
import { Suspense } from 'react';
// eslint-disable-next-line no-restricted-imports
import type { Props as ChartProps } from 'react-apexcharts';
import lazyWithPreload from '../App/LazyLoadRetry';

// eslint-disable-next-line no-restricted-imports
const Chart = lazyWithPreload(() => import('react-apexcharts'));

export const MChart = (props: ChartProps) => {
  return (
    <Suspense fallback={<Spinner />}>
      <Chart type="line" {...props} />
    </Suspense>
  );
};

export default MChart;
